import React from 'react';
export function DocumentIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-157">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" data-id="element-158" />
      <polyline points="14 2 14 8 20 8" data-id="element-159" />
      <line x1="16" y1="13" x2="8" y2="13" data-id="element-160" />
      <line x1="16" y1="17" x2="8" y2="17" data-id="element-161" />
      <line x1="10" y1="9" x2="8" y2="9" data-id="element-162" />
    </svg>;
}